"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeItemHeight = void 0;
var computeItemHeight = function (treeId) {
    var _a;
    var firstItem = document.querySelector("[data-rct-tree=\"".concat(treeId, "\"] [data-rct-item-container=\"true\"]"));
    return (_a = firstItem === null || firstItem === void 0 ? void 0 : firstItem.offsetHeight) !== null && _a !== void 0 ? _a : 39;
};
exports.computeItemHeight = computeItemHeight;
